import React from 'react';
import { connect } from 'react-redux';

import { confirmNewsletterOptIn } from '../../redux/auth/newsletterOptIn/actions';
import { updateQueryString } from '../../redux/router/actions';

import NewsletterOptInModal from './NewsletterOptInModal';

import * as selectors from './selectors';

const NewsletterOptInModalConnected = (props) => <NewsletterOptInModal {...props} />;

const mapStateToProps = (state) => ({
  activated: selectors.selectActivated(state),
  error: selectors.selectError(state),
  errorMessage: selectors.selectErrorMessage(state),
  isLoading: selectors.selectIsLoading(state),
  isVisible: selectors.selectIsVisible(state),
});

const mapActionsToProps = {
  confirmNewsletterOptIn,
  updateQueryString,
};

export default connect(mapStateToProps, mapActionsToProps)(NewsletterOptInModalConnected);
